import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
    apiKey: "AIzaSyA2nb_oNX8HF8h_onN23CUlFVtEyGJjDK4",
    authDomain: "dental-lab-system.firebaseapp.com",
    projectId: "dental-lab-system",
    storageBucket: "dental-lab-system.firebasestorage.app",
    messagingSenderId: "551651535147",
    appId: "1:551651535147:web:c12d499e074f2dbf077d6e",
    measurementId: "G-TXZTSDN1V9"
};

const app = initializeApp(firebaseConfig);

// ── App Check (2026-09-16 대표 승인) ──
// 목적: 우리 웹이 아닌 곳에서 Cloud Functions·Firestore 를 호출하는 것을 줄인다(검색 CF 남용 방지).
// 설정: .env 의 REACT_APP_APPCHECK_SITE_KEY 에 reCAPTCHA 사이트 키를 넣으면 켜진다. 값이 없으면 건너뛴다(기존 화면 그대로 동작).
//   - REACT_APP_APPCHECK_PROVIDER='enterprise' 면 reCAPTCHA Enterprise, 없거나 다른 값이면 reCAPTCHA v3.
//   - 개발 중 디버그 토큰: 브라우저 콘솔에서 self.FIREBASE_APPCHECK_DEBUG_TOKEN = true 로 실행(또는 .env 에
//     REACT_APP_APPCHECK_DEBUG_TOKEN=<콘솔에서 발급받은 토큰>) 후 새로고침 → 콘솔에 찍힌 토큰을 Firebase 콘솔
//     App Check > 앱 > 디버그 토큰에 등록. 운영 빌드에서는 값을 비워 둘 것.
//   - 서버 강제(enforce)는 Firebase 콘솔에서 따로 켠다. 모니터링으로 정상 비율을 확인한 뒤 전환(기본 off).
const appCheckSiteKey = process.env.REACT_APP_APPCHECK_SITE_KEY;
if (typeof window !== 'undefined' && appCheckSiteKey) {
    try {
        // 코드 분할 — App Check 를 안 쓰는 환경에서는 번들만 남고 초기화는 하지 않는다
        // eslint-disable-next-line global-require
        const { initializeAppCheck, ReCaptchaV3Provider, ReCaptchaEnterpriseProvider } = require('firebase/app-check');
        if (process.env.REACT_APP_APPCHECK_DEBUG_TOKEN) {
            window.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.REACT_APP_APPCHECK_DEBUG_TOKEN;
        }
        const provider = process.env.REACT_APP_APPCHECK_PROVIDER === 'enterprise'
            ? new ReCaptchaEnterpriseProvider(appCheckSiteKey)
            : new ReCaptchaV3Provider(appCheckSiteKey);
        initializeAppCheck(app, { provider, isTokenAutoRefreshEnabled: true });
        console.log('[AppCheck] 초기화 완료');
    } catch (e) {
        // 초기화 실패가 화면을 막지 않게 — 기록만 남긴다(조용한 실패 금지)
        console.error('[AppCheck] 초기화 실패 — App Check 없이 계속합니다', e);
    }
} else if (typeof window !== 'undefined') {
    console.warn('[AppCheck] REACT_APP_APPCHECK_SITE_KEY 가 없어 App Check 를 건너뜁니다(콘솔 등록 전 정상).');
}
export const auth = getAuth(app);
// WebChannel 스트림 내부 버그(INTERNAL ASSERTION ca9/b815) 회피 + 프록시/불안정 네트워크 대응
// 자동 감지 long-polling: 가능하면 WebChannel, 안 되면 long-polling으로 폴백
export const db = initializeFirestore(app, {
    experimentalAutoDetectLongPolling: true,
});
export const storage = getStorage(app);

// Firebase Cloud Messaging
let messaging = null;
if (typeof window !== 'undefined' && 'Notification' in window) {
    try {
        messaging = getMessaging(app);
    } catch (error) {
        console.log('FCM not supported:', error);
    }
}

export { messaging, getToken, onMessage };
export default app;
